export default __webpack_public_path__ + "static/media/La-semaine.66e4a137.jpg";